module.exports = __webpack_public_path__ + "fenyxRysingCaracter.png";